import { BBC_ORDER_MANAGEMENT as type } from '../actions/bbcOrderManagementTypes';

const initialState = {
    bbcBoxUpdateLoading: false,
    bbcBoxUpdate: {},
    bbcBoxUpdateError: false,
    getBbcOrdersByTimeLoading: false,
    getBbcOrdersByTime: [],
    getBbcOrdersByTimeError: false,
}

export default function bbcOrderManagementReducer(state = initialState, action) {
    switch (action.type) {
        case type.BBC_BOX_UPDATE:
            return {
                ...state,
                bbcBoxUpdateLoading: true
            }
        case type.BBC_BOX_UPDATE_SUCCESS:
            return {
                ...state,
                bbcBoxUpdate: action.payload,
                bbcBoxUpdateLoading: false
            }
        case type.BBC_BOX_UPDATE_FAIL:
            return {
                ...state,
                bbcBoxUpdateLoading: false,
                bbcBoxUpdateError: action.payload
            }
        case type.GET_BBC_ORDERS_BY_TIME:
            return {
                ...state,
                getBbcOrdersByTimeLoading: true
            }
        case type.GET_BBC_ORDERS_BY_TIME_SUCCESS:
            return {
                ...state,
                getBbcOrdersByTime: action.payload,
                getBbcOrdersByTimeLoading: false
            }
        case type.GET_BBC_ORDERS_BY_TIME_FAIL:
            return {
                ...state,
                getBbcOrdersByTimeLoading: false,
                getBbcOrdersByTimeError: action.payload
            }
        default:
            return state;
    }
}